export const EXPLORE_OTHER_CARD_TYPES_EXPERIMENT_NAME =
  'card_6684_cardfinder_branch_header_and_switcher';
